enum ConditionType {
  Good = "Good",
  Fair = "Fair",
  Poor = "Poor",
  MustBeReplaced = "Must be Replaced",
  UnderConstruction = "Under Construction",
}

export default ConditionType;
